import React, { ElementType, ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import { ExternalLink, Svg } from 'ui'
import { DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'

export default function ItemContainer({
  icon,
  title,
  learnMorePath,
  sx,
}: {
  icon: ElementType<{ descriptiveText?: string }>
  title: string
  learnMorePath?: string
  sx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <Flex
      sx={{
        minWidth: '31.9rem',
        flexDirection: 'column',
        p: '2.4rem',
        gap: '2.4rem',
        alignItems: 'center',
        borderRadius: '1.2rem',
        border: '1px solid',
        borderColor: 'blueYonder20',
        backgroundColor: 'blueYonder10',
        ...sx,
      }}
    >
      <Flex
        sx={{
          width: '10rem',
          height: '10rem',
          borderRadius: '1.4rem',
          background: 'white8',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Svg svg={icon} descriptiveText={`Icon for ${title} integration`} />
      </Flex>
      <Flex
        sx={{ flexDirection: 'column', maxWidth: '27.1rem', gap: '0.8rem', alignItems: 'center' }}
      >
        <Text variant="size21Weight600" sx={{ color: 'aliceBlue' }}>
          {title}
        </Text>
        {learnMorePath && (
          <ExternalLink
            to={`${DOCS_CONTROL_D_DOMAIN}/docs/${learnMorePath}`}
            sx={{
              color: 'aliceBlue',
              cursor: 'pointer',
              textDecoration: 'underline',
              whiteSpace: 'nowrap',
            }}
          >
            <Text variant="size14Weight500Line138Letter056">Learn more</Text>
          </ExternalLink>
        )}
      </Flex>
    </Flex>
  )
}
